import { render } from "./Block1.vue?vue&type=template&id=3c9dc115&scoped=true"
import script from "./Block1.vue?vue&type=script&lang=js"
export * from "./Block1.vue?vue&type=script&lang=js"

import "./Block1.vue?vue&type=style&index=0&id=3c9dc115&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9dc115"]])

export default __exports__